import { tv } from 'tailwind-variants';

const stepIndicatorStyles = tv({
    slots: {
        stepIndicatorContainer: `
      iris:flex
      iris:list-none
      iris:items-start
      iris:justify-between
      iris:gap-(--base-space-px-0)
      iris:p-(--base-space-px-0)
    `,
    },
    variants: {
        inverse: {
            true: "",
            false: "",
        },
    },
});

export { stepIndicatorStyles as default };
